export class Utilities {
    upperCaseFirst(name) {
        return name
            ? name.replace(/^.{1}/, (firstChar) => firstChar.toUpperCase())
            : "";
    }
    lowerCaseFirst(name) {
        return name
            ? name.replace(/^.{1}/, (firstChar) => firstChar.toLowerCase())
            : "";
    }
    postFile(url, formData) {
        return new Promise((resolve, reject) => {
            let xhr = new XMLHttpRequest();
            xhr.open("POST", url);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr);
                    }
                }
            };
            xhr.onerror = reject;
            xhr.send(formData);
        });
    }
    camelCaseToNormal(str: string) {
        if (str) {
            str = this.upperCaseFirst(str);
            str.replace(/[A-Z]/g, (e) => ` ${e.toUpperCase()}`);
        }
        return str;
    }
    currencyFormat(x: any) {
        if (!x) {
            return "";
        }
        let xStr: string = x.toString();
        let afterPoint: string = "";
        if (xStr.indexOf(".") > 0)
            afterPoint = xStr.substring(xStr.indexOf("."), xStr.length);
        let xNumber: number = Math.floor(x);
        xStr = xNumber.toString();
        let lastThree: string = xStr.substring(xStr.length - 3);
        let otherNumbers: string = xStr.substring(0, xStr.length - 3);
        if (otherNumbers !== "") lastThree = "," + lastThree;
        return (
            otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
            lastThree +
            afterPoint
        );
    }
    getFinalPrice(
        tenure: any,
        upto36m: string = "100",
        M37_60: string = "100",
        M61_84: string = "100",
        finalCarPrice: string,
        loanAmt: string
    ) {
        let finalPer: number = parseInt(M61_84);
        tenure = parseInt(tenure);
        if (tenure >= 0 && tenure <= 36) {
            finalPer = parseInt(upto36m);
        }
        if (tenure >= 37 && tenure <= 60) {
            finalPer = parseInt(M37_60);
        }
        let finalCarPriceCal = (parseInt(finalCarPrice) * finalPer) / 100;
        return Math.floor(
            finalCarPriceCal > parseInt(loanAmt)
                ? parseInt(loanAmt)
                : finalCarPriceCal
        );
    }
    getEmi(InterestRate, LoanAmount, Months) {
        InterestRate = parseFloat(InterestRate) / 100;
        LoanAmount = parseFloat(LoanAmount) * -1;
        Months = parseFloat(Months);
        return Math.abs(
            Math.round(
                ((InterestRate / 12) *
                    LoanAmount *
                    Math.pow(1 + InterestRate / 12, Months)) /
                    (1 - Math.pow(1 + InterestRate / 12, Months))
            )
        );
    }
    getDateInFormat(date?: string, options?: {}) {
        return (date ? new Date(date) : new Date()).toLocaleDateString(
            undefined,
            options
        );
    }

    amountInWord(amount?: any) {
        amount = amount ? amount : 0;
        var a = [
            "",
            "one ",
            "two ",
            "three ",
            "four ",
            "five ",
            "six ",
            "seven ",
            "eight ",
            "nine ",
            "ten ",
            "eleven ",
            "twelve ",
            "thirteen ",
            "fourteen ",
            "fifteen ",
            "sixteen ",
            "seventeen ",
            "eighteen ",
            "nineteen ",
        ];
        var b = [
            "",
            "",
            "twenty",
            "thirty",
            "forty",
            "fifty",
            "sixty",
            "seventy",
            "eighty",
            "ninety",
        ];

        if ((amount = amount.toString()).length > 9) return "";
        let n = ("000000000" + amount)
            .substr(-9)
            .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!n) return;
        var str = "";
        str +=
            parseFloat(n[1]) != 0
                ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "crore "
                : "";
        str +=
            n[2].toString() != "0"
                ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "lakh "
                : "";
        str +=
            n[3].toString() != "0"
                ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) +
                  "thousand "
                : "";
        str +=
            n[4].toString() != "0"
                ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) +
                  "hundred "
                : "";
        str +=
            n[5].toString() != "0"
                ? (str != "" ? "and " : "") +
                  (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) +
                  "only "
                : "";
        return str;
    }
    formValidation(
        lead: object,
        arg: Array<{
            name: string;
            valid: any;
            errorText: string;
            moreValid?: Function;
        }>
    ) {
        let errorList = {};
        arg.forEach((field) => {
            console.log(field.name, !field.valid.test(lead[field.name]));
            errorList[field.name] = !field.valid.test(lead[field.name])
                ? field.errorText
                : field.name in lead
                ? ""
                : field.errorText;
            if (field.moreValid) {
                errorList[field.name] =
                    errorList[field.name] == ""
                        ? field.moreValid(lead[field.name])
                            ? field.errorText
                            : ""
                        : errorList[field.name];
            }
        });
        return errorList;
    }
    checkPropertiesEmpty(obj) {
        for (var key in obj) {
            if (obj[key] !== null && obj[key] != "" && obj[key] != undefined)
                return false;
        }
        return true;
    }
}
